<template>
    <div>
        <div class="h1">
            <div class="logo">
                <img src="../../assets/img/market/market102/logo.png" alt="">
            </div>
            <div class="s1">
                <img src="../../assets/img/market/market102/s1.png" alt="">
            </div>
            <div class="s2">
                <h4>活动端口开放通知！</h4>
                <div class="li-1">
                    由于预订人数迅猛增长，广大用户踊跃参与。<span>兔年团购惠活动端口将于8日下午18：00正式开放!因预订人数众多，将按照尾款到账时间的先后顺序开通权限。席位有限请参团用户火速补齐尾款，以免错失活动优惠！</span>
                </div>
                <div class="li-2">
                    <div class="lis1">
                        <p>参团人数:</p><span>{{ people }}</span>
                    </div>
                    <div class="lis2">
                        <p> 剩余端口:</p><span>{{ surplus }}</span>
                    </div>
                </div>
                <div class="li-3">
                    <div class="ss3">
                        <div class="wen">
                            团购福利：赠送权限<span>6</span>个月
                        </div>
                    </div>
                </div>
            </div>
            <div class="s3">
                <div class="w">
                    <div class="lis1">
                        <img src="../../assets/img/market/market102/s4.png" alt="">
                    </div>
                    <div class="lis2">
                        <img src="../../assets/img/market/market102/s5.png" alt="">
                    </div>
                    <div class="lis3">
                        <div ref="chart"></div>
                    </div>

                </div>
            </div>
            <div class="s4">
                （ 9800元/半年）
            </div>
            <div class="s6">
                <div class="w">
                    <div class="lis1">
                        活动倒计时
                    </div>
                    <count-down class="daojishi" :endTime="endTime" :endText="endText" />
                </div>
            </div>
            <div class="b_text">
                活动最终解释权归北京天相财富管理顾问有限公司所有，股市有风险，投资需谨慎。
            </div>
        </div>
    </div>
</template>

<script>

import countDown from '@/components/countDown'//引入路径，可更改
export default {
    data() {
        return {
            endTime: new Date("2023/02/10 18:00:00").getTime() / 1000 + ' ',
            //  console.log(endTime)=>得到毫秒  1658030420 可在方法里面放入后台数据,new Date('放后台数据').getTime() / 1000 +  ' ',但要记得调用方法
            endText: '活动结束',
            xAxis: [],
            yAxis: [],
            people: "36",
            newtime: "",
            month: "",
            // 剩余端口
            surplus: ""
        };
    }, components: {
        countDown
    },
    mounted() {
        // echarts
        this.getEchartData()
        console.log("new Date().getTime():", new Date().getTime())
        this.newtime = new Date().getTime();
        this.timess()
    },
    methods: {
        getEchartData() {
            const chart = this.$refs.chart
            if (chart) {
                const myChart = this.$echarts.init(chart)
                const option = {
                    legend: {},
                    tooltip: {},
                    dataset: {

                    },
                    // 设置图表得宽高
                    grid: {
                        //与绝对定位相似，top，left，right，bottom 设定是根据上级盒子宽高来计算

                        top: "10%",

                        left: "20%",

                        right: "20%",

                        bottom: "5%"

                    },
                    xAxis: [{
                        type: "category",
                        data: [""],
                        axisTick: {
                            length: 5
                        }

                    }
                    ],
                    yAxis: [
                        // {
                        //     axisLabel: {
                        //         min: 0,
                        //         max: 5,
                        //         show: true,
                        //         textStyle: { // 字体配置
                        //             color: '#ffe674',
                        //             fontSize: '12',
                        //             lineHeight: 14
                        //         },
                        //         formatter: function (value) {
                        //         },
                        //         formatter: function (value) {
                        //             var texts = [];
                        //             if (value == 0) {
                        //                 texts.push('0人');
                        //             }
                        //             else if (value <= 1) {
                        //                 texts.push('100人');
                        //             }
                        //             else if (value <= 2) {
                        //                 texts.push('200人');
                        //             }
                        //             else if (value <= 3) {
                        //                 texts.push('300人');
                        //             }
                        //             else if (value <= 4) {
                        //                 texts.push('400人');
                        //             }
                        //             else {
                        //                 texts.push('500人');
                        //             }
                        //             return texts;
                        //         }
                        //     }
                        // },

                        {
                            type: "value",
                            min: 0,
                            max: 500,
                            show: true,

                            axisLabel: {
                                textStyle: { // 字体配置
                                    color: '#ffe674',
                                    fontSize: '12',
                                    lineHeight: 14
                                },

                            },


                            splitLine: {
                                //显示分割线
                                show: false,
                            },
                        },



                        {
                            min: 0,
                            max: 5,
                            show: true,
                            axisLabel: {
                                min: 0,
                                max: 5,
                                show: true,
                                textStyle: { // 字体配置
                                    color: '#ffe674',
                                    fontSize: '12',
                                    lineHeight: 14
                                },
                                formatter: function (value) {
                                    var texts = [];
                                    if (value == 0) {
                                        texts.push('赠送1个月');
                                    }
                                    else if (value <= 1) {
                                        texts.push('赠送2个月');
                                    }
                                    else if (value <= 2) {
                                        texts.push('赠送3个月');
                                    }
                                    else if (value <= 3) {
                                        texts.push('赠送4个月');
                                    }
                                    else if (value <= 4) {
                                        texts.push('赠送5个月');
                                    }
                                    else {
                                        texts.push('赠送6个月');
                                    }
                                    return texts;
                                }
                            }
                        }

                    ],

                    series: [
                        {
                            type: 'bar',
                            data: [
                                500
                            ],
                            barWidth: 100,
                            itemStyle: {
                                normal: {
                                    color: function (params) {
                                        const colorList = ["#df2b35",];
                                        return colorList[params.dataIndex];
                                    }
                                }
                            }
                        }
                    ]
                }
                myChart.setOption(option)
                window.addEventListener("resize", function () {
                    myChart.resize()
                })
            }
            this.$on('hook:destroyed', () => {
                window.removeEventListener("resize", function () {
                    myChart.resize();
                });
            })
        },
        // 判断当前时间戳是几并且赋值给变量
        timess() {
            var timer
            var peo
            timer = this.newtime - 1675737740574
            peo = Math.floor(timer / 600000)
            // this.people = 36 + peo
            this.people = peo + 365;

            // if (this.people > 500) {
            //     this.people = 500
            // }
            var timer1 = this.newtime - 1675849760215
            this.surplus = 375 - Math.floor(timer1 / 300000)
            if (this.surplus < 0) {
                this.surplus = 0
            }
            console.log(this.surplus);
            this.month = Math.floor(this.people / 100) + 1;
            this.getEchartData();
        }
    }
};
</script>
<style lang="less" scoped>
* {
    font-size: 16px;
}



.h1 {
    margin: 0 auto;
    width: 1900px;
    height: 1000px;
    background: url(../../assets/img/market/market102/bg.png)no-repeat center;
    position: relative;

    .logo {

        position: absolute;
        top: 10px;
        left: 240px;
    }

    .s1 {
        position: absolute;
        top: 83px;
        left: 415px;


    }

    .s2 {
        width: 832px;
        height: 430px;
        background: url(../../assets/img/market/market102/s2.png)no-repeat center;
        position: absolute;
        top: 368px;
        left: 246px;

        h4 {
            width: 100%;
            text-align: center;
            font-size: 30px;
            font-weight: 600;
            color: #c21515;
            margin: 0;
            padding-top: 20px;
        }

        .li-1 {
            font-size: 24px;
            color: #2e0352;
            width: 700px;
            margin: 0 auto;
            line-height: 1.5;

            span {
                color: #c21515;
                font-size: 24px;

            }
        }

        .li-2 {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 5px;

            .lis1 {
                width: 236px;
                height: 76px;
                background: url(../../assets/img/market/market102/btn1.png);
                font-size: 20px;
                color: #2f0407;
                display: flex;
                align-items: center;
                justify-content: center;

                span {
                    font-weight: 600;
                    font-size: 60px;
                }
            }

            .lis2 {
                margin-left: 29px;
                width: 236px;
                height: 76px;
                background: url(../../assets/img/market/market102/btn2.png);
                font-size: 20px;
                color: #ffef64;
                display: flex;
                align-items: center;
                justify-content: center;

                span {
                    font-size: 60px;
                    font-weight: 600;
                }
            }
        }

        .li-3 {
            margin-top: 14px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            .ss3 {
                width: 485px;
                height: 106px;
                background: url(../../assets/img/market/market102/s3.png);

                .wen {
                    padding-left: 145px;
                    padding-top: 50px;
                    width: 100%;
                    height: 100%;
                    font-size: 24px;
                    color: #2f0407;
                    font-weight: 600;

                    span {
                        font-size: 36px;
                        color: #d71422;
                    }
                }



            }
        }
    }

    .s3 {
        width: 569px;
        height: 755px;
        border: 3px solid #fff8a5;
        position: absolute;
        top: 44px;
        left: 1111px;
        border-radius: 10px;

        .w {
            width: 569px;
            height: 755px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .lis1 {
                padding-top: 26px;
            }

            .lis2 {
                margin-top: 18px;
                margin-bottom: 18px;
            }

            .lis3 {
                width: 500px;

                div {
                    width: 500px;
                    height: 500px;
                }
            }



        }


    }

    .s4 {
        position: absolute;
        font-size: 16px;
        color: #ffffff;

        right: 262px;
        bottom: 284px;
    }

    .s6 {
        position: absolute;
        right: 239px;
        bottom: 62px;
        width: 1439px;
        height: 120px;
        background: url(../../assets/img/market/market102/s6.png);

        .w {
            width: 1439px;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;

            .lis1 {
                color: #340d0b;
                font-size: 57px;
                font-weight: 600;
                margin-right: 80px;
            }

            .daojishi {
                color: #af2918;
                font-size: 60px;
                font-weight: 600;
            }
        }
    }

    .b_text {
        position: absolute;
        bottom: 22px;
        left: 590px;
        font-size: 18px;
        color: #fff;
    }
}
</style>




// WEBPACK FOOTER //
// src/pages/market/market102.vue